<template>
  <div>
    <Header></Header>

    <div class="w80 centerAuto">
      <div class="w90Mobile">
        <Cart
          v-if="menu && menu.length > 0"
          :businessTime="$DateFormat(businessTime, 'HH:mm:ss')"
          @changeFatherCartBoolean="changeFatherCartBoolean"
          @cartInfoFn="cartInfoFn"
          :cartInfoProps="cartInfo"
          :menu="menu"
          :addCartBoolean="addCartBoolean"
          ref="addNewarrData"
        ></Cart>
      </div>
      <div class="mt20 mmt5" v-if="menu && menu.length > 0">
        <!-- <div class="w90Mobile"><router-link class="initaStyle cp" to="/chooseLocation" >{{storeObj.storename}}</router-link> > <span class="color2 bolder">Choose Product</span></div> -->
        <div class="flexcc mt30 mb30 mobileStart">
          <div class="flexcc redBall mobileBall">
            <img src="@/assets/first-active.png" alt="" class="chooseIcon" />
            <span class="ballText bold">Choose Product</span>
          </div>
          <div class="ballLine mr15 ml15"></div>
          <div class="flexcc mobileBall">
            <img src="@/assets/second.png" alt="" class="chooseIcon" /><span
              class="ballText"
              >Choose Flavors</span
            >
          </div>
          <div class="ballLine mr15 ml15"></div>
          <div class="flexcc mobileBall">
            <img src="@/assets/three.png" alt="" class="chooseIcon" /><span
              class="ballText"
              >Toppings & others Optional</span
            >
          </div>
        </div>
      </div>

      <div
        class="flex flex-around titleBox mt30 mb30 mmt5 mmb5"
        v-if="!combitemsList"
      >
        <div
          v-for="(item, index) in menu"
          :key="item.id+'.'"
          class="center cateBoxIcon cp"
          v-on:click="menuClk(index)"
        >
          <img
            :src="
              menuIndex == index
                ? globalData.url + item.sicon
                : globalData.url + item.icon
            "
            class="w90Mobile"
            alt=""
          />
          <div
            class="color1 mt15 mobileHide"
            :class="menuIndex == index ? 'bolder' : ''"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="contentBox mt10 mb10 flex" v-if="menu[menuIndex]">
        <selectCart
          v-if="selectList && Object.keys(selectList).length"
          @cartInfoFn="cartInfoFn"
          :categoryid="menu[menuIndex].id"
          :cartInfo="cartInfo"
          :orderstoreid="storeObj.orderstoreid"
        ></selectCart>
        <div
          v-if="
            selectList.step &&
            selectList.step[stepIndex].modifierGroup &&
            selectList.step[stepIndex].modifierGroup[flavorsIndex]
          "
          class="flex flex-wrap p-re"
        >
          <div
          
            v-for="(pitem, pindex) in selectList.step[stepIndex].modifierGroup[
              flavorsIndex
            ].modifiers"
            :key="pitem.id+'-'"
            class="pBox flexcc"
          >
            <Product
              :pitem="pitem"
              :pindex="pindex"
              :modifiersChoose="true"
              :pgroup="selectList.step[stepIndex].modifierGroup"
              :orderstoreid="storeObj.orderstoreid"
            ></Product>
          </div>
        </div>

        <div class="flex flex-wrap p-re" v-else>
          <div
            class="pBox flexcc"
            v-for="(pitem, pindex) in combitemsList ||
            menu[menuIndex].combitems"
            :key="pitem.id+','"
            :class="
              !pitem.step &&
              (!pitem.available ||
                (menu[menuIndex].id == 'HOT' &&
                  hotitemid.indexOf(pitem.id) != -1) ||
                (menu[menuIndex].id != 'HOT' && itemid.indexOf(pitem.id) != -1))
                ? 'grayscale'
                : ''
            "
          >
            <Product
              @addCartBooleanFn="addCartBooleanFn"
              @cartInfoFn="cartInfoFn"
              :cartInfo="cartInfo"
              :pitem="pitem"
              :menu="menu"
              :menuIndex="menuIndex"
              :pindex="pindex"
              :orderstoreid="storeObj.orderstoreid"
            ></Product>
          </div>
          <template v-if="!combitemsList">
            <div
              class="pBox flexcc"
              v-for="(pitem, pindex) in menu[menuIndex].items"
              :key="pitem.id+';'"
              :class="
                !pitem.step &&
                (!pitem.available ||
                  (menu[menuIndex].id == 'HOT' &&
                    hotitemid.indexOf(pitem.id) != -1) ||
                  (menu[menuIndex].id != 'HOT' &&
                    itemid.indexOf(pitem.id) != -1))
                  ? 'grayscale'
                  : ''
              "
            >
              <Product
                :businessTime="$DateFormat(businessTime, 'HH:mm:ss')"
                :isNormalProduct="true"
                @editStatusFn="editStatusFn"
                @addCartBooleanFn="addCartBooleanFn"
                @cartInfoFn="cartInfoFn"
                :cartInfo="cartInfo"
                :pitem="pitem"
                :menu="menu"
                :menuIndex="menuIndex"
                :pindex="pindex"
                :orderstoreid="storeObj.orderstoreid"
              ></Product>
            </div>
          </template>
        </div>

        <img
          v-if="!menu[menuIndex].items || menu[menuIndex].items.length <= 1"
          src="@/assets/campImg.png"
          alt=""
          class="camoImg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import SelectCart from "@/components/SelectCart";
import Product from "@/components/Product";
import { log } from "console";
import { setInterval } from "timers";
export default {
  components: { SelectCart, Product },
  data() {
    return {
      menu: [],
      menuIndex: 0,
      globalData: "",
      storeObj: {},
      addCartBoolean: false,
      hotitemid: [],
      itemid: [],
      interval: "",
      cartInfo: {},
      businessTime: {},
    };
  },
  computed: {
    ...mapState(["selectList", "stepIndex", "flavorsIndex"]),
    combitemsList() {
      if (this.selectList && this.selectList.step) {
        return this.selectList.step[this.stepIndex].product;
      }
    },
    unavailableObj() {
      const menu = this.menu;
      let hotitem = [],
        item = [];
      for (let i = 0; i < menu.length; i++) {
        let items = menu[i].items || menu[i].combitems;
        if (!items) break;
        // console.log(123123321,items&&items[0]?items[0].step:"");
        for (let j = 0; j < items.length; j++) {
          let obj = {};
          obj.id = items[j].id;
          obj.modifierGroup = [];
          if (menu[i].id == "HOT" && items[j].discount) {
            obj.discount = menu[i].items[j].discount;
          }

          items[j].modifierGroup &&
            items[j].modifierGroup.forEach(function (modifierGroupValue) {
              let obj2 = {};
              obj2.id = modifierGroupValue.id;
              obj2.modifiers = [];
              modifierGroupValue.modifiers.forEach(function (modifiersValue) {
                obj2.modifiers.push({ id: modifiersValue.id });
              });
              obj.modifierGroup.push(obj2);
            });

          if (menu[i].id == "HOT") {
            hotitem.push(obj);
          } else if (items && items[j] && items[j].step) {
            items[j].step.forEach((ele) => {
              ele.productid.forEach((pid, index) => {
                item.push(pid);
              });
            });
          } else {
            item.push(obj);
          }
        }
        // console.log("pid111",item)
      }
      return { hotitem, item };
    },
  },
  methods: {
    ...mapMutations(["ADD_SELECTLIST"]),
    updateCurrentTime() {
      this.businessTime = new Date();
    },
    editStatusFn(data) {
      let menu = this.menu;
      let available = menu[data.menuIndex].items[data.pindex].available;
      if (available == data.status) {
        return false;
      } else {
        menu[data.menuIndex].items[data.pindex].available = data.status;
        this.sortItem(menu);
      }
    },
    getStoreTime() {
      let that = this;
      // this.$loading();
      return new Promise((resolve, reject) => {
        this.$http
          .Get(
            "mobile/storeorderstatus?orderstoreid=" +
              this.storeObj.orderstoreid,
            {}
          )
          .then(function (res) {
            if (res.code == 1) {
              resolve(res);
            } else {
              reject(res);
            }
            // that.$loading().close();
          })
          .catch(function (err) {
            // that.$loading().close();
            reject(err);
          });
      });
    },
    // selectCombitems(id){
    //   let combitems=this.menu[this.menuIndex].combitems;
    //   for(let i=0;i<combitems.length;i++){
    //     if(combitems[i].id==id){
    //       console.log(combitems[i]);
    //       this.ADD_SELECTLIST(combitems[i]);
    //       break;
    //     }
    //   }

    // },
    // selectFlavors(id, pindex) {
    //   let that=this;
    //   let modifierGroup=this.menu[this.menuIndex].items[pindex].modifierGroup;
    //   let trackingData=this.menu[this.menuIndex].items[pindex];
    //   if(modifierGroup&&modifierGroup.length>0){
    //     this.braze.logCustomEvent("Product viewed", {
    //       "Product ID": trackingData.id,
    //       Category: that.menu[that.menuIndex].name,
    //       Price: trackingData.price,
    //       Campaign: trackingData.discount?trackingData.discount.campaignname:"",
    //       Timestamp: new Date(),
    //       Source:""
    //     });
    //     this.$router.push({
    //       name: "orderDetail",
    //       params: { menu: this.menu, pindex: pindex, menuIndex: this.menuIndex },
    //     });
    //   }else{
    //     this.addToCart(pindex)
    //   }

    // },

    // 获取隐私协议内容
    getStore() {
      let that = this;
      this.$loading();
      return new Promise((resolve, reject) => {
        this.$http
          .Get(
            "mobile/menusimple?orderstoreid=" + this.storeObj.orderstoreid,
            {}
          )
          .then((res) => {
            if (res.code == 1) {
              // res.menu[0].items[0].discount.starttime="16:56:10";
              // res.menu[0].items[0].discount.endtime="17:47:29";
              res.menu = res.menu.filter(item => item.id !== "Comb");//删除comb数据
              res.menu.forEach(function (ele) {
                if (ele.combitems)ele.combitems=undefined;//删除comb数据
                console.log("ele.combitems",ele.combitems)
                if (ele.combitems) {
                  let combitemsPrice = 0;
                  ele.combitems.priceAdd = ele.combitems.price;
                  ele.combitems.forEach(function (eleComb) {
                    // console.log(eleComb)
                    if (eleComb && eleComb.step) {
                      eleComb.step.forEach(function (eleStep, index) {
                        let arrPrice = [];
                        if (
                          eleStep &&
                          eleStep.product &&
                          eleStep.product.length
                        ) {
                          eleStep.product.forEach(function (eleProduct) {
                            // combitemsPrice+=eleProduct.price;
                            if (eleProduct.available)
                              arrPrice.push(eleProduct.price);
                          });

                          if (arrPrice.length)
                            combitemsPrice += Math.min.apply(Math, arrPrice);
                        }
                      });
                    }
                    eleComb.price = combitemsPrice;
                  });
                }
              });
              // console.log(123123)
              that.menu = res.menu;
              // that.sortModifiers();
              that.sortItem();
              resolve(res);
            } else {
              // console.log(res)
              reject(res);
            }
            that.$loading().close();
          })
          .catch(function (err) {
            // console.log(err)
            that.$loading().close();
            reject(err);
          });
      });
    },
    sortItem(menu) {
      let that = this;
      let arr = menu || this.menu;
      arr &&
        arr.forEach((element) => {
          element.items = that.sortFn(element.items || element.combitems);
          element.items.forEach((ele2) => {
            ele2.modifierGroup &&
              ele2.modifierGroup.forEach((ele3) => {
                ele3.modifiers = that.sortFn(ele3.modifiers);
              });
          });
        });
      this.$forceUpdate();
    },
    moveArray(arr, sourceIndex, targetIndex) {
      // splice 将目标元素替换并将原结果扔回来赋值给它
      arr[sourceIndex] = arr.splice(targetIndex, 1, arr[sourceIndex])[0];
    },
    sortFn(arr) {
      let that = this;
      var sourceIndexes = [];
      arr.forEach((item, index) => {
        if (item.available == 0) {
          sourceIndexes.push(index);
        }
      });

      // 遍历索引数组，移动元素
      sourceIndexes.forEach((sourceIndex) => {
        that.moveArray(arr, sourceIndex, arr.length);
      });
      // console.log(arr);

      // 过滤数组，去除 undefined 项
      var result = arr.filter((item) => {
        return item !== undefined || !!item;
      });
      return result;
    },

    sortModifiers() {
      let menu = this.menu;
      menu.forEach((ele) => {
        ele.items.forEach((itemsEle) => {
          itemsEle.modifierGroup &&
            itemsEle.modifierGroup.forEach((mEle) => {
              mEle.modifiers.sort(function (a, b) {
                return a.name.localeCompare(b.name);
              });
            });
        });
      });
    },
    menuClk(index) {
      this.menuIndex = index;
    },
    changeFatherCartBoolean(data) {
      this.addCartBoolean = data;
    },
    cartInfoFn(data) {
      // console.log(data,555);
      this.cartInfo = data;
    },
    addCartBooleanFn(data) {
      this.addCartBoolean = data;
    },
    unavailableitem() {
      let that = this;
      // console.log("settimeout")
      return new Promise((resolve, reject) => {
        this.$http
          .Post("mobile/unavailableitem", {
            orderstoreid: this.storeObj.orderstoreid,
            hotitem: this.unavailableObj.hotitem,
            item: this.unavailableObj.item,
          })
          .then((res) => {
            if (res.code == 1) {
              if (res.hotitemid && res.hotitemid.length > 0) {
                that.hotitemid = res.hotitemid.toString();
              }
              if (res.itemid && res.itemid.length > 0) {
                that.itemid = res.itemid.toString();
              }
              // setTimeout(() => {
              //   that.itemid+=",MOD_7828";
              //   that.itemid+=",ITEM_3660";
              // }, 5000);
              resolve(res);
            }
          });
      });
    },
    async refreshItem() {
      // console.log("refreshItem")
      let result = await this.unavailableitem();
      if (this.interval == "STOP") return;
      this.interval = setTimeout(() => {
        this.refreshItem();
      }, 30000);
    },
    matchCate(cateid) {
      // console.log(cateid);

      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i].id == cateid) {
          this.menuIndex = i;
          break;
        }
      }
    },
    searchStore() {
      let that = this;
      this.$loading();
      return new Promise((resolve) => {
        this.$http
          .Post("mobile/storelist", {})
          .then((res) => {
            if (res.code == 1) {
              let newList = res.storelist.filter(
                (item) => item.orderstoreid != "False" && item.alloworder == 1
              );
              this.$loading().close();
              resolve(newList);
            } else {
              this.$loading().close();
              alert(res.msg);
            }
          })
          .catch((err) => {
            this.$loading().close();
          });
      });
    },
  },
  async created() {
    let that = this;
    try {
      this.storeObj = JSON.parse(localStorage.getItem("storeObj"));
    } catch (e) {}

    let paramsStore = that.$route.query.storenameFromApp;
    if (paramsStore) {
      let storeList = await this.searchStore();
      let [store] = storeList.filter(
        (store) => store.orderstoreid == paramsStore
      );
      this.storeObj = store;
      localStorage.setItem("storeObj", JSON.stringify(this.storeObj));
    } else {
      if (!this.storeObj) {
        this.$router.push({ name: "chooseLocation" }, () => {});
      }
    }

    this.getStore()
      .then(function (res) {
        let cateid = that.$route.query.cateid;
        that.matchCate(cateid);
        that.refreshItem();
      })
      .catch(function (res) {});

    this.globalData = this.$root.globalData;
    if (this.$route.query.addCartBoolean == 1) {
      this.addCartBoolean = true;
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.addCartBoolean = 0;
      this.$router.push({
        name: "order",
        query: query,
      });
    }
    setInterval(() => {
      this.updateCurrentTime();
    }, 1000);
  },

  watch: {
    // itemid:function(value){
    //   console.log("itemid",value)
    // }
  },
  mounted() {
    window.addEventListener("pageshow", () => {
      // this.$loading().close();
      let sub = localStorage.getItem("submit");
      if (sub == 1) {
        localStorage.setItem("submit", 0);
        location.reload();
      }
    });
  },
  updated() {},
  beforeDestroy() {
    clearTimeout(this.interval);
    this.interval = "STOP";
    this.$loading().close();
    // console.log("index beforeDestroy")
  },
  destroyed() {},
};
</script>

<style scoped src='./common.css'></style>